(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/utils/wins-helper.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/utils/wins-helper.js');
"use strict";


const {
  getProductId,
  isKeno,
  isJoker
} = svs.numbergames.productMapping;
svs.numbergames.rules.utils.winsHelper = {
  isWinningRow(_ref) {
    let {
      correctNumbers,
      correctExtraNumbers,
      product = '',
      kungKeno = false,
      level = 0
    } = _ref;
    let productId = getProductId(product);
    if (isJoker(productId)) {
      productId = 'joker';
    }
    const gameRules = svs.numbergames.rules[productId];
    if (!gameRules) {
      svs.numbergames.rules.logger.warn("No rules found using productName: \"".concat(product, "\""));
      return false;
    }
    if (isKeno(product)) {
      return gameRules.winConditions.some(winCondition => level === winCondition.level && correctNumbers >= winCondition.numbers && kungKeno === winCondition.kungKeno);
    }
    return gameRules.winConditions.some(winCondition => correctNumbers >= winCondition.numbers && (!winCondition.numbersExtra || correctExtraNumbers >= winCondition.numbersExtra));
  }
};

 })(window);